module.exports = __webpack_public_path__ + "static/img/Symptoms.4fd2630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Symptoms.png
// module id = eChZ
// module chunks = 7